import { useState } from 'react';
import { Box, Button2, Dialog, Separator, theme } from '@frameio/vapor';
import { ExportLocation } from './ExportLocation';
import TEXT from './generated/TEXT/ExportLocationDialog';

TEXT.DEFINE({
  /** Label for the cancel button in the export location dialog */
  cancel: 'Cancel',
  /** Label for the select button in the export location dialog */
  select: 'Select',
});

export const ExportLocationDialog = ({
  isShowing,
  onRequestClose,
  folderId,
  projectId,
  onFolderIdChange,
  onProjectIdChange,
  startInFoldersView = false,
}: {
  folderId: string | null;
  projectId: string | null;
  isShowing: boolean;
  onRequestClose: () => void;
  onFolderIdChange: (folderId: string | null) => void;
  onProjectIdChange: (projectId: string | null) => void;
  startInFoldersView?: boolean;
}) => {
  const [pendingFolderId, setPendingFolderId] = useState<string | null>(null);
  const [pendingProjectId, setPendingProjectId] = useState<string | null>(null);
  const canSelect = !!pendingFolderId;

  return (
    <Dialog
      isShowing={isShowing}
      onRequestClose={() => {
        onRequestClose();
        setPendingFolderId(null);
        setPendingProjectId(null);
      }}
      style={{ maxWidth: '350px' }}
      zIndex={theme.zIndices.modal + 1}
    >
      <Box
        backgroundColor="primary"
        display="flex"
        flexDirection="column"
        height="450px"
      >
        <ExportLocation
          folderId={pendingFolderId ?? folderId}
          projectId={pendingProjectId ?? projectId}
          setFolderId={setPendingFolderId}
          setProjectId={setPendingProjectId}
          startInFoldersView={startInFoldersView}
        />
        <Separator color="primary" />
        <Box
          display="flex"
          justifyContent="space-between"
          paddingX={16}
          paddingY={8}
        >
          <Button2 onPress={onRequestClose}>{TEXT.cancel}</Button2>
          <Button2
            isDisabled={!canSelect}
            onPress={() => {
              onFolderIdChange(pendingFolderId);
              onProjectIdChange(pendingProjectId);
              setPendingFolderId(null);
              setPendingProjectId(null);
              onRequestClose();
            }}
            variant="primary"
          >
            {TEXT.select}
          </Button2>
        </Box>
      </Box>
    </Dialog>
  );
};
